// extracted by mini-css-extract-plugin
export var rateTable = "_59-0";